import { create } from '@storybook/theming';

export default create({
  base: 'light',
  brandTitle: 'Dynamic resourcing',
  brandUrl: 'https://ey.com',
  brandImage: 'https://ue2ddisvalblo01.blob.core.windows.net/static/ey_logo_slogan.png?sp=r&st=2022-04-04T17:27:44Z&se=2025-04-05T02:27:44Z&spr=https&sv=2020-08-04&sr=b&sig=fRGHYJThZ3Sgn%2BdAly2sLm9K2pGyZuLS0kM7NqfIxzg%3D',
});
